import { APPLY_JOB_FILTER } from '../actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case APPLY_JOB_FILTER:
      state = action.payload.data
      return state
  }
  return state
}
